import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { FormBuilder } from '@angular/forms';
import { Globals } from "../../../../globals";
import { ConfigurationServices } from "../../services";
import { TranslateService } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';

/**
 * Generated class for the ConfigurationPaymentVerifonePage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-configuration-payment-verifone',
  templateUrl: 'configuration-payment-verifone.html',
})
export class ConfigurationPaymentVerifonePage {

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public fb: FormBuilder,
    public configurationServices: ConfigurationServices,
    public globals: Globals,
    public translate: TranslateService,
    private http: HttpClient,) {

        //notificacion de interes sobre el pay
        if(!this.globals.restaurant.payment_method_verifone || this.globals.restaurant.payment_method_verifone == undefined){
          this.notificationSlack();
        }
  }

  changeVerifone(active){
    this.configurationServices.afs.collection('restaurants').doc(this.globals.restaurant_uid).update({
      'payment_method_verifone': active
    }).then(() => {
      this.globals.restaurant.payment_method_verifone = active;
    });
  }
  async notificationSlack() {
    var msg = 'El usuario ' + this.globals.restaurant.company + ', ' + this.globals.restaurant.name + ' (' + this.globals.restaurant.email + ') ha abierto el config de Pay Verifone.';

    //send
    await this.http.post(this.globals.api_path + 'slack/integrations', {
      msg: msg,
    }, {}).subscribe(async data => {
    },
      err => {}
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/configuration/configuration-payment-methods/configuration-payment-verifone/configuration-payment-verifone.ts